import { ConfigService } from '@nextgen-web-framework/core';
import { useMasterData } from '@nextgen-web-framework/all';
import type { CountryInterface, RegFlowConfigMasterData, CartConfigType } from '@commerce-profile-webcomponents/sdk';
import { RegistrationValidations } from '../components/RegistrationIdVerificationStep/types/propTypes';
import type { MyAccountData } from './types/propTypes';

export type { CountryInterface };
export const useCountryMasterData = () => {
  const { NEXT_PUBLIC_TENANT, NEXT_PUBLIC_COUNTRY } = ConfigService.getConfigs();
  const tenant = String(NEXT_PUBLIC_TENANT);
  const siteCountryCode = String(NEXT_PUBLIC_COUNTRY).toLowerCase();
  const MasterCountryList = (useMasterData<CountryInterface>('MasterCountryList') ?? []) as CountryInterface[];
  const data = MasterCountryList?.filter((data: CountryInterface) => data.affiliateCode !== tenant)
    ?.map((data: CountryInterface) => ({
      ...data,
    }))
    .sort((a: CountryInterface, b: CountryInterface) => a.countryName.localeCompare(b.countryName));

  const currentCountry = MasterCountryList?.find(
    (data: CountryInterface) => data.affiliateCode === tenant && data.ISO2?.toLowerCase() === siteCountryCode,
  );

  const allData = [...MasterCountryList].sort((a: CountryInterface, b: CountryInterface) =>
    a.countryName.localeCompare(b.countryName),
  );

  return {
    data,
    allData,
    currentCountry,
  };
};

export const useMyAccountProfileConfig = () => useMasterData<MyAccountData[]>('MyAccountProfileConfig') ?? [];
export const useMyAccountAddressConfig = () => useMasterData<MyAccountData[]>('MyAccountAddressConfig') ?? [];
export const useRegistrationFieldsMasterData = () =>
  useMasterData<RegistrationValidations[]>('RegistrationFieldsMasterData');
export const useRegistrationFlowConfig = () => useMasterData<RegFlowConfigMasterData>('RegistrationFlowConfigList');
export const useCartConfig = () => {
  const { NEXT_PUBLIC_COUNTRY } = ConfigService.getConfigs();
  const countryCode = String(NEXT_PUBLIC_COUNTRY)?.toLowerCase();
  const configs = useMasterData<CartConfigType[]>('CartConfig') ?? [];
  if (configs.length === 0) {
    return [];
  }
  return [
    configs.find((config) => config?.pk?.toLowerCase() === countryCode) ??
      // fallback to first config if not found
      configs[0],
  ];
};
